import type { components } from "@/api-schema";

const RELATION_BASE_PATHS = {
  Application: "/ram/application",
  Branch: "/masterdata/branch",
  Brand: "/masterdata/brand",
  Company: "/masterdata/company",
  CompanyGroup: "/masterdata/company-group",
  Customer: "/masterdata/customer",
  Department: "/masterdata/department",
  Group: "/ram/group",
  JobFunction: "/masterdata/job-function",
  Occupation: "/masterdata/occupation",
  User: "/phonebook",
} as const satisfies Partial<Record<keyof components["schemas"], string>>;

export type RelationSubject = keyof typeof RELATION_BASE_PATHS;

export function getRelationPath(subject: RelationSubject, uuid: string): string {
  return `~${RELATION_BASE_PATHS[subject]}/${uuid}`;
}
